import { EntityList } from '@/types/Entity'
import { CONSTANTS } from '@/types/enum/constants'
import { routeBackOfficeCompanionAdminCommon } from '@/lib/routes/backoffice/common/routeBackOfficeCompanionAdminCommon'

const getBackOfficeGroupCompanionAdmin = [...routeBackOfficeCompanionAdminCommon].map(route => ({
  ...route,
  entity: [EntityList.PHARMEDIGROUP],
  roles: [CONSTANTS.ROLE_DYNAMIC_ROUTE_ROLE_SUPER_ADMIN],
}))

export default getBackOfficeGroupCompanionAdmin
